class SocialShop extends HTMLElement {
  constructor() {
    super()

    this.cardListSlider = null
    this.modalCardListSlider = null

    this.$cardList = this.querySelector('.social-shop__card-list')
    this.$cards = this.querySelectorAll('.social-shop__card')
    this.$modal = this.querySelector('.social-shop__modal')
    this.$modalCardList = this.querySelector('.social-shop__modal__card-list')
    this.$modalCardArrows = this.querySelectorAll('.social-shop__modal__arrow')
    this.$modalCloseButtons = this.querySelectorAll('.social-shop__modal__close')
    this.$modalBackButtons = this.querySelectorAll('.social-shop__modal__back')
    this.$modalBackdrop = this.querySelector('.backLayer')
    this.$openWidgetButtons = this.querySelectorAll('[data-block="open-widget"]')
    this.$productDetailWidgets = this.querySelectorAll('[data-block="product-detail-widget"]')
    this.$modals = this.querySelectorAll('[data-block="modal"]')
  }

  connectedCallback() {
    this.initSlider()

    this.$cards.forEach(($card) => {
      $card.addEventListener('click', this.handleClickCard)
    })

    this.$modalCardArrows.forEach(($arrow) => {
      $arrow.addEventListener('click', (e) => {
        const { name } = e.target
        this.modalCardListSlider[name]?.(false, false)
      })
    })

    this.$modalCloseButtons.forEach(($button) => {
      $button.addEventListener('click', this.handleCloseModal)
    })

    this.$modalBackdrop.addEventListener('click', this.handleCloseModal)

    this.$openWidgetButtons.forEach(($button) => {
      
      $button.addEventListener('click', this.handleOpenWidget)
    })

    this.$modalBackButtons.forEach(($button) => {
      $button.addEventListener('click', this.handleBackModal)
    })

    document.addEventListener('pixel:add_to_cart', () => {
      this.$productDetailWidgets.forEach((widget) => {
        widget.classList.add('social-shop__modal__card--hidden')
        setTimeout(() => {
          this.handleCloseModal()
        }, 200)
      })
    })
  }

  initSlider() {
    const options = this.getSliderOptions()
    this.cardListSlider = new Flickity(this.$cardList, options.cardListSlider)
    this.modalCardListSlider = new Flickity(this.$modalCardList, options.modalCardListSlider)
   const nextButton = this.querySelector('.flickity-prev-next-button.next');
const prevButton = this.querySelector('.flickity-prev-next-button.previous');

if (nextButton) {
    const nextSvg = nextButton.querySelector('svg');
    if (nextSvg) {
        nextSvg.remove();
        nextButton.innerHTML = `
            <svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>
        `;
    }
}

if (prevButton) {
    const prevSvg = prevButton.querySelector('svg');
    if (prevSvg) {
        prevSvg.remove();
        prevButton.innerHTML = `
            <svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" ></path></svg>
        `;
    }
}

  }

  getSliderOptions = () => {
    const cardListSlider = {
      cellAlign: 'left',
      contain: true,
      groupCells: 3,
      pageDots: true,
      draggable: false,
    }

    const modalCardListSlider = {
      cellAlign: 'center',
      contain: true,
      groupCells: 1,
      pageDots: false,
      prevNextButtons: false,
      draggable: false,
      selectedAttraction: 1,
      friction: 1,
    }

    if (matchMedia('(max-width: 767px)').matches) {
      cardListSlider.groupCells = 1
      cardListSlider.prevNextButtons = false
      cardListSlider.draggable = true
    }

    return { cardListSlider, modalCardListSlider }
  }

  handleOpenModal = (index) => {
    this.$modal.classList.add('social-shop__modal--active')
    document.body.classList.add('o-hidden')
    this.modalCardListSlider?.resize()
    this.modalCardListSlider?.select?.(index)
    const backLayer = this.$modal.querySelector('.backLayer')
    if (backLayer) backLayer.style.display = 'block'
  }

  handleCloseModal = () => {
    this.$modal.classList.remove('social-shop__modal--active')
    document.body.classList.remove('o-hidden')
    this.$productDetailWidgets.forEach((widget) => {
      widget.classList.add('social-shop__modal__card--hidden')
    })
    this.$modals.forEach((modal) => {
      modal.classList.remove('social-shop__modal__card--hidden')
    })
  }

  handleBackModal = ({ target }) => {
    const parent = target.closest('.social-shop__modal__card__wrapper')
    const modal = parent.querySelector('[data-block="modal"]')
    const widget = parent.querySelector('[data-block="product-detail-widget"]')
    modal?.classList.remove('social-shop__modal__card--hidden')
    widget?.classList.add('social-shop__modal__card--hidden')
  }

  handleOpenWidget = ({ target }) => {
    
    const parent = target.closest('.social-shop__modal__card__wrapper')
    const modal = parent.querySelector('[data-block="modal"]')
    const widget = parent.querySelector('[data-block="product-detail-widget"]')
    modal?.classList.add('social-shop__modal__card--hidden')
    setTimeout(() => {
      widget?.classList.remove('social-shop__modal__card--hidden')
    }, 100)
  }

  handleClickCard = (e) => {
    let $element = e.target
    const $parent = $element.closest('.social-shop__card')
    if ($parent) $element = $parent

    const { index } = $element.dataset

    this.handleOpenModal(index)
  }
}

export default SocialShop
